module.exports = __webpack_public_path__ + "static/media/toasty.b519bdc0.png";